import React from "react";
import PropTypes from "prop-types";
import PreviewLayout from "../../components/Layout/PreviewLayout";
import { EventPageTemplate } from "../../templates/event-page";

const EventPagePreview = ({ entry, widgetFor }) => (
	<PreviewLayout>
		<EventPageTemplate
			siteTitle="Preview!"
			page={{
				image: entry.getIn(["data", "image"]),
				imageYPosition: entry.getIn(["data", "imageYPosition"]),
				tags: entry.getIn(["data", "tags"]),
				title: entry.getIn(["data", "title"]),
				eventDate: entry.getIn(["data", "eventDate"]),
				link: entry.getIn(["data", "link"]),
				featuredpost: entry.getIn(["data", "featuredpost"]),
				date: entry.getIn(["data", "date"]),
				content: widgetFor("body"),
			}} />
	</PreviewLayout>
);

EventPagePreview.propTypes = {
	entry: PropTypes.shape({
		getIn: PropTypes.func,
	}),
	widgetFor: PropTypes.func,
};

export default EventPagePreview;
